export default "__VITE_ASSET__d20b1181__"